/**
 * React Query Configuration
 *
 * Sets up QueryClient with sensible defaults for caching and retries
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cached data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000,

      // Cached data is garbage collected after 10 minutes
      gcTime: 10 * 60 * 1000,

      // Retry failed requests once (for network errors)
      retry: 1,

      // Don't refetch on window focus in development (can be annoying)
      refetchOnWindowFocus: import.meta.env.PROD,

      // Refetch when mounting a component with stale data
      refetchOnMount: true,
    },
    mutations: {
      // Don't retry mutations by default (user-initiated actions)
      retry: false,
    },
  },
});
